import type { ErrorAlert } from './types';
import type errorPt from '../../i18n/errors/pt';

export const errorStore = defineStore('errorStore', {
  state: (): ErrorStore.ErrorState => {
    return {
      errors: [],
    };
  },
  getters: {
    totalErrors: (state) => state.errors.length,
    getLatesError: (state) => {
      const latestError = state.errors[state.errors.length - 1];
      if (latestError && typeof latestError.id === 'string') {
        return {
          ...latestError,
          id: latestError.id as keyof typeof errorPt.errors,
        };
      }
      return null;
    },
  },
  actions: {
    ERRORS_RESET() {
      this.errors = [];
    },

    ADD_ERROR(error: ErrorAlert) {
      this.errors.push(error);
    },

    REMOVE_ERROR(error: ErrorAlert) {
      const index = this.errors.findIndex((currentError) => error.id === currentError.id);

      if (index > -1) {
        this.errors.splice(index, 1);
      }
    },
  },
});

namespace ErrorStore {
  export type ErrorState = {
    errors: ErrorAlert[];
  };
}
